import React from 'react';

// Utils
import withAuth from '../../../utils/hocs/withAuth';
import withSidebar from '../../../utils/hocs/withSidebar';
import SCOPE from '../../../utils/gate/scope';
import withPermission from '../../../utils/hocs/withPermission';
import productTypes from '../../../constants/productTypes';

// Components
import ProductLogistic from '../../../components/views/establishment/Products/Common/ProductLogistic/ProductLogistic';

function ExtraLogistic() {
  return (
    <ProductLogistic productType={productTypes.extras} />
  );
}

export default withAuth(
  withPermission(
    withSidebar(ExtraLogistic),
    {
      scopes: [SCOPE.update_ownEst_extra],
    },
  ),
);
